import "./App.css";
import { ApplicationRoot } from "./host/ApplicationRoot";

export default function App() {
    return <ApplicationRoot />;
}
